module.exports = __webpack_public_path__ + "static/custom_macaron-fbbaad915dad396b7877806645ad72e7.jpg";